import ScrapingPage from './ScrapingPage'
export default ScrapingPage
